module.exports = __webpack_public_path__ + "img/eat_out_16.9cfdeaf3.jpg";